import PrimoCalculator from "./PrimoCalculator";

export default PrimoCalculator;